import { useEffect, useState } from "react"
import { path } from "../constants"
import { api } from "../helpers"

export default function Dashboard(){
    const [status, setStatus] = useState({})
    const getStatus = () => {
        api.get(path.dashboard).then(response => {
            let data = response.data
            if(data.success){
                setStatus(data.status)
            }
        })
    }
    useEffect(getStatus, [])
    
    return (
        <div className='overflow-y-auto flex-1 rounded-md bg-white p-6 grid grid-cols-4 gap-4 items-start'>
            <div className='p-6 rounded-md shadow-lg flex flex-col items-center gap-4 justify-center'>
                <h1 className='text-[45px] font-bold opacity-[0.8]'>{status.tenants?.toLocaleString()}</h1>
                <h4>Active Tenants</h4>
            </div>
            <div className='p-6 rounded-md shadow-lg flex flex-col items-center gap-4 justify-center'>
                <h1 className='text-[45px] font-bold opacity-[0.8]'>{status.events?.toLocaleString()}</h1>
                <h4>Events Created</h4>
            </div>
            <div className='p-6 rounded-md shadow-lg flex flex-col items-center gap-4 justify-center'>
                <h1 className='text-[45px] font-bold opacity-[0.8]'>{status.txns?.toLocaleString()}</h1>
                <h4>Transactions</h4>
            </div>
            <div className='p-6 rounded-md shadow-lg flex flex-col items-center gap-4 justify-center'>
                <h1 className='text-[45px] font-bold opacity-[0.8]'>{status.employees?.toLocaleString()}</h1>
                <h4>Employees Managed</h4>
            </div>
        </div>
    )
}